import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router";
import { PDFViewer, PDFDownloadLink, StyleSheet } from "@react-pdf/renderer";
import '../../../Styles/Components/PublicForms/Dialog_alert.css';
import '../../../Styles/Components/Dashboards/Report/Pree_Pdf_Viewer.css';
import { useNavigate } from "react-router-dom";
import isTokenExpired from "../../PublicForms/isTokenExpired.js";
import Config from "../../PublicForms/Config.js";
import LoaderComp from "../../PublicForms/Loader.js";
import Pdf_Post from "./Pdf_Post.js";

const styles = StyleSheet.create({
  page: {
    backgroundColor: "#d11fb6",
    color: "white",
  },
  section: {
    margin: 10,
    padding: 10,
  },
  viewer: {
    width: '100vw',
    height: '100vh',
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
});

const Pree_Pdf_Post = () => {
  const [loading, setLoading] = useState(true);
  const [width, setWidth] = useState(0);
  const Navigate = useNavigate();
  const [runProcess, setRunProcess] = useState(true);
  const [printData, setPrintData] = useState([]);
  const [message, setMessage] = useState([]);
  const [messTitle, setMessTitle] = useState("");
  const [showDialog, setShowDialog] = useState(false);
  const { number, cost, numberJeld } = useParams();

  useEffect(() => {
    if (localStorage.getItem('token')) {
      const token = localStorage.getItem('token');
      if (isTokenExpired(token)) {
        localStorage.removeItem('token');
        Navigate("/login");
      }
    } else {
      Navigate("/login");
    }
  }, []);

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // اجرای زنجیره‌ای و به ترتیب: ابتدا GET و سپس PUT
  useEffect(() => {
    const handleGetThenPut = async () => {
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };

      try {
        // ۱. مرحله اول: گرفتن دیتا (GET)
        const getResponse = await axios.get(
          `${Config.apiBaseUrl}/api/SubscriptDetails/1`,
          { headers }
        );

        if (getResponse.status === 200) {
            console.log(getResponse)
          // ذخیره دیتای گرفته شده برای گزارش
          setPrintData(getResponse.data);

          // ۲. مرحله دوم: پس از موفقیت GET، ارسال درخواست ویرایش (PUT)
          const putUrl = `${Config.apiBaseUrl}/api/SubscriptDetails?cost=${parseFloat(cost)}&lastV=${number + ""}&numberJeld=${parseFloat(cost) > 0 ? parseInt(numberJeld) : 0}`;
          
          const putResponse = await axios.put(putUrl, {}, { headers });

          if (putResponse.status === 204 || putResponse.status === 200) {
            console.log(putResponse)
            // هر دو عملیات با موفقیت انجام شد، حالا صفحه آماده نمایش است
            setLoading(false);
          } else {
            setLoading(false);
            setMessTitle("خطا");
            setMessage((prev) => [...prev, "خطا در به‌روزرسانی اطلاعات. لطفا مجددا تلاش کنید"]);
            setShowDialog(true);
          }
        } else {
          setLoading(false);
          setMessTitle("خطا");
          setMessage((prev) => [...prev, "خطا در دریافت اطلاعات. لطفا مجددا تلاش کنید"]);
          setShowDialog(true);
        }
      } catch (err) {
        console.log(err)
        setLoading(false);
        console.log(err);

        if (err.response !== null && err.response !== undefined) {
          setMessage([]);
          if (err.response.status === 401) {
            Navigate("/login");
          } else if (err.response.status === 500) {
            setMessTitle("خطا");
            setMessage((prevMessages) => [
              ...prevMessages,
              err.response.data?.detail || "خطای سرور",
            ]);
            setShowDialog(true);
          } else {
            setMessTitle("خطا");
            setMessage((prevMessages) => [
              ...prevMessages,
              "لطفا مجددا تلاش کنید",
            ]);
            setShowDialog(true);
          }
        } else if (err.message === "Network Error") {
          setMessTitle("خطا");
          setMessage((prevMessages) => [
            ...prevMessages,
            "برقراری ارتباط با سرور امکان پذیر نمی باشد",
          ]);
          setShowDialog(true);
        } else {
          setMessTitle("خطا");
          setMessage((prevMessages) => [
            ...prevMessages,
            "لطفا مجددا تلاش کنید",
          ]);
          setShowDialog(true);
        }
      }

      setRunProcess(false);
    };

    if (runProcess === true) {
      handleGetThenPut();
    }
  }, [runProcess]);

  // ۱. حالت لودینگ
  if (loading) {
    return (
      <div className="personLst">
        <p className="personLst-loader-txt">لطفا چند لحظه صبر کنید...</p>
        <div className="personLst-loader">
          <LoaderComp />
        </div>
      </div>
    );
  }

  // ۲. حالت بروز خطا
  if (showDialog) {
    return (
      <div className="pree-factor-error" style={{ textAlign: "center", padding: "20px" }}>
        <h3>{messTitle}</h3>
        {message.map((msg, index) => (
          <p key={index} style={{ color: "red" }}>{msg}</p>
        ))}
      </div>
    );
  }

  // ۳. بررسی خالی نبودن دیتا
  if (!printData || (Array.isArray(printData) && printData.length === 0)) {
    return (
      <div className="pree-factor-empty" style={{ textAlign: "center", padding: "20px" }}>
        <p>داده‌ای برای گزارش‌گیری یافت نشد.</p>
      </div>
    );
  }

  // ۴. رندر نسخه دسکتاپ و موبایل
  if (width > 768) {
    return (
      <div className='pree-factor' style={styles.viewer}>
        <div className="pdf" style={styles.viewer}>
          <PDFViewer width="100%" height="100vh" className="app" style={styles.viewer}>
            <Pdf_Post printData={printData} newVersion={number} />
          </PDFViewer>
        </div>
      </div>
    );
  } else {
    return (
      <div className='pree-factor'>
        <div className="pdf">
          <PDFDownloadLink
            className="pdf-download"
            document={<Pdf_Post printData={printData} newVersion={number} />}
            fileName='reportSubscriptMouood.pdf'
          >
            {({ loading: pdfLoading }) =>
              pdfLoading ? 'در حال آماده‌سازی فایل PDF...' : (
                <div className="txt-pdf">
                  دانلود
                </div>
              )
            }
          </PDFDownloadLink>
        </div>
      </div>
    );
  }
};

export default Pree_Pdf_Post;
